import sanityClient from '@sanity/client';
import ImageUrlBuilder  from '@sanity/image-url';

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID || 'afkr4dm7';

const config = {
    projectId,
    dataset: 'production',
    apiVersion: '2022-02-01',
};

export const readClient = sanityClient({
    ...config,
    useCdn: true,
});

const builder = ImageUrlBuilder(readClient);
    
    
    export const urlFor = (source) => builder.image(source)
